export default "__VITE_ASSET__JuO02az4__"